import { isNil } from '@flowio/is';
import { RequestPaymentParameters } from '../../types';
import getDeviceFingerprintDetails from '../../utilities/getDeviceFingerprintDetails';

import fetchEncryptionKey from './fetchEncryptionKey';

export default function cardRawForm(
  params: RequestPaymentParameters,
): Promise<io.flow.v0.models.PaymentMethodDataAuthorizeCard> {
  const pm = params.data.paymentMethod;
  if (isNil(pm) || pm.id !== 'card' || pm.type !== 'raw_form') {
    throw new Error('cardRawForm: called with incorrect params.');
  }
  return Promise.all([
    // dynaically import jsencrypt to keep size of SDK down.
    import(
    /* webpackChunkName: "jsencrypt" */
    /* webpackPrefetch: true */
      'jsencrypt'
    ),
    fetchEncryptionKey(params.config.organization),
  ]).then(([{ default: JSEncrypt }, publicKey]) => {
    const jsencrypt = new JSEncrypt();
    jsencrypt.setPublicKey(publicKey);

    const encrytedCardNumber = jsencrypt.encrypt(pm.form.number);

    if (encrytedCardNumber === false) {
      throw new Error('cardRawForm: Encryption failed');
    }

    const {
      number, // remove raw number from form.
      ...restForm
    } = pm.form;

    const postForm: io.flow.v0.models.PaymentMethodDataAuthorizeCard = {
      type: 'authorize_card',
      card_data: {
        type: 'card_pci_details',
        ...restForm,
        card_number: {
          type: 'cipher',
          cipher: encrytedCardNumber,
        },
      },
      device_fingerprint_details: getDeviceFingerprintDetails(),
      cvv: pm.form.cvv,
    };

    return postForm;
  });
}
